import { HTMLAttributes } from 'react'

import Picture from '@/components/picture'

interface Description {
  heading: string
  value: string
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  id: string
  isActive: boolean
  image: string
  imageAlt: string
  descriptionList: Description[]
  listStyle?: string
  sectionStyle?: string
}

const ValueDetailedItem = ({
  id,
  isActive,
  image,
  imageAlt,
  descriptionList,
  listStyle,
  sectionStyle,
  ...props
}: Props) => (
  <section
    id={id}
    className={`${
      isActive ? 'flex' : 'hidden'
    } flex flex-wrap md:items-center ${sectionStyle}`}
    {...props}
  >
    <Picture
      image={`/assets/images/about-us/${image}`}
      imageAlt={imageAlt}
      pictureStyle="md:w-1/2 w-full md:px-4"
      imageStyle="w-full h-full"
    />
    <article className="md:w-1/2 md:mt-0 w-full mt-6 md:pl-[8.6%] pl-5">
      <ul className="list-disc space-y-8">
        {descriptionList.map(({ heading, value }) => (
          <li
            key={heading}
            className="md:text-2xl text-lg md:leading-[29px] leading-[21px] font-natosans-medium md:text-neutral-100 text-neutral-90"
          >
            <h4>{heading}</h4>
            <p className="md:text-lg text-[#4f4f4f] text-base md:leading-6 leading-5 mt-2 font-natosans-light">
              {value}
            </p>
          </li>
        ))}
      </ul>
    </article>
  </section>
)

export default ValueDetailedItem
